var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "campaign-form" }, [
    _c("h3", [_vm._v("Campaign Details")]),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-col w-full" }, [
      _c(
        "div",
        { staticClass: "w-full" },
        [
          _c("field-input", {
            attrs: {
              model: _vm.$v.campaign.name,
              "field-name": "Title",
              "label-position": "top",
              placeholder:
                "eg: Coles new store opening or Mount View Netball Club Awards Night",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-row w-full spacer-y-2" }, [
        _c(
          "div",
          { class: _vm.$hasErrorClass(_vm.$v.campaign.start_date, "w-1/2") },
          [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "start_date" } },
              [_vm._v("\n          Start date\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "margin-r-2 input-group" },
              [
                _c("flat-pickr", {
                  staticClass: "form-control w-full",
                  attrs: {
                    id: "start_date",
                    config: _vm.defaultDateConfig,
                    placeholder: "DD/MM/YYYY",
                    name: "Start date",
                  },
                  model: {
                    value: _vm.$v.campaign.start_date.$model,
                    callback: function ($$v) {
                      _vm.$set(_vm.$v.campaign.start_date, "$model", $$v)
                    },
                    expression: "$v.campaign.start_date.$model",
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ],
              1
            ),
            _vm._v(" "),
            _c("vuelidate-help", {
              attrs: {
                field: _vm.$v.campaign.start_date,
                label: "Start date",
                "custom-messages": {
                  insideDateBounds:
                    "This campaign has bookings that are outside this date range. Please update those bookings.",
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$hasErrorClass(_vm.$v.campaign.end_date, "w-1/2") },
          [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "end_date" } },
              [_vm._v("\n          End date\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("flat-pickr", {
                  key: _vm.$v.campaign.start_date.$model,
                  staticClass: "form-control w-full",
                  attrs: {
                    id: "end_date",
                    config: _vm.endDateConfig,
                    placeholder: "DD/MM/YYYY",
                    name: "End date",
                  },
                  model: {
                    value: _vm.$v.campaign.end_date.$model,
                    callback: function ($$v) {
                      _vm.$set(_vm.$v.campaign.end_date, "$model", $$v)
                    },
                    expression: "$v.campaign.end_date.$model",
                  },
                }),
                _vm._v(" "),
                _vm._m(1),
              ],
              1
            ),
            _vm._v(" "),
            _c("vuelidate-help", {
              attrs: {
                field: _vm.$v.campaign.end_date,
                label: "End date",
                "custom-messages": {
                  insideDateBounds:
                    "This campaign has bookings that are outside this date range. Please update those bookings.",
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$hasErrorClass(
            _vm.$v.campaign.description,
            "w-full redactor-editor-wrapper margin-t-2"
          ),
        },
        [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: "campaign_description" },
            },
            [_vm._v("\n        Campaign description\n      ")]
          ),
          _vm._v(" "),
          _c("redactor", {
            attrs: {
              id: "campaign_description",
              name: "campaign_description",
              placeholder:
                "Add information related to the broader campaign, what you are trying to achieve, who's involved and the description of the types of deliverables. This information will only be available to those who are involved in the campaign and not those responding to requests",
              options: _vm.redactorOptions,
            },
            model: {
              value: _vm.$v.campaign.description.$model,
              callback: function ($$v) {
                _vm.$set(_vm.$v.campaign.description, "$model", $$v)
              },
              expression: "$v.campaign.description.$model",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-block pull-right" }, [
            _vm.$v.campaign.description.$error &&
            _vm.$v.campaign.description.required === false
              ? _c("span", [_vm._v("Campaign description is required")])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "margin-t-4" }, [_vm._t("action-buttons")], 2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-clear": "" } },
      [_c("i", { staticClass: "fa fa-times" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-clear": "" } },
      [_c("i", { staticClass: "fa fa-times" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }